import type { hush as en } from '../en/hush';

export const hush: typeof en = {
  hushedChat: '嘘。关卡结束后才能聊天。',
  chatPlaceholder: '说点什么…',
  levelOf: (level, levels) => `第 ${level} / ${levels} 关`,
  gameOver: '游戏结束',
  gameEnded: '游戏已中止',
  waitingRoom: '等待室',
  you: (_first) => '你',
  player: '一位玩家',
  level: (level) => `第 ${level} 关`,
  allCards: (count) => `全部 ${count} 张牌`,
  asEnded: '结束时的牌堆',
  alone: '叫上好友更好玩。',
  setup: (players, levels) =>
    `${players} 人，${levels} 关。不说话，一起按顺序打出每一张牌。`,
  guestSetup: (players, levels) => `${players} 人，${levels} 关。`,
  lastLife: (level) => `第 ${level} 关：失去最后一条命`,
  unfinished: (level) => `第 ${level} 关：未完成`,
  clean: (level, lifeBack) =>
    `第 ${level} 关：零失误${lifeBack ? '，赢回一条命' : ''}`,
  livesLost: (level, lives) => `第 ${level} 关：失去 ${lives} 条命`,
  won: (levels) => `全部 ${levels} 关通过了。`,
  lost: (level) => `在第 ${level} 关用完了命。`,
  wonDetail: (lives) =>
    lives === 0 ? '一起做到了。' : `一起做到了，还剩 ${lives} 条命。`,
  lostDetail: (cleared, levels) => `一起通过了 ${cleared} / ${levels} 关。`,
  levelByLevel: '每关表现',
  playedBy: '一起玩的伙伴',
  stillHeld: '剩余手牌',
  playerHeld: (name) => `${name} 的剩余手牌`,
  nothingLeft: '没有剩余手牌',
  dealtWhenReady: '所有人准备好后发牌',
  lowestHere: '房间里最小的牌放在这里',
  cardsEach: (count) => `每人 ${count} 张牌`,
  pile: '牌堆',
  underTop: '顶牌下面的牌',
  allPlayed: (count) => `全部 ${count} 张牌已打出`,
  playedDiscarded: (played, discarded) =>
    `打出 ${played} 张牌，弃置 ${discarded} 张牌`,
  lowestFirst: '从最小的牌开始',
  noCards: '没有剩余手牌',
  cardsToGo: (count) => `还剩 ${count} 张牌`,
  ready: '已准备',
  yourReady: '你准备好了',
  readyWhen: '准备好了就开始',
  chatTiming: '关卡开始后不能聊天，结束后重新开放。',
  firstRule:
    '没有回合，不许说话：觉得时机到了，就打出你最小的牌。全桌每一张牌都要按从小到大的顺序落到牌堆上。关卡开始后聊天会锁定。',
  readyButton: '我准备好了',
  waitingOthers: '等其他人准备。',
  nextUp: '下一关',
  nextLevel: (level) =>
    `第 ${level} 关每人发 ${level} 张牌。所有人都要再次准备。`,
  hand: '你的手牌',
  watchingHand: '你正在观战，队伍会一言不发地出牌。',
  handEmpty: '没有牌可出了。安静地看着牌堆。',
  play: (card) => `出 ${card}`,
  onlyLowest: '只能打出你最小的牌。',
  opensSoon: '马上可以出牌。',
  returns: (names, _count) => `${names} 回来后，倒计时结束就继续。`,
  goesSoon: '马上继续出牌。',
  pausedClock: '已暂停',
  getReady: '准备开始',
  waitingCount: (count) => `正在等 ${count} 位玩家。`,
  readyCount: (count) => `${count} 人准备好了。`,
  pressReady: '准备好了就按“我准备好了”。',
  hush: '嘘',
  everyoneHolds: (count) => `每人手上有 ${count} 张牌。`,
  toStart: '后开始',
  playedCard: (name, card) => `${name} 打出了 ${card}`,
  mistakeCount: (count) => `还有 ${count} 张更小的牌没出。失去一条命。`,
  toGoOn: '后继续',
  paused: '已暂停',
  waitingHolder: (names, held) =>
    `正在等 ${names} 回来，还有 ${held} 张牌没出。`,
  waitingHoldersCount: (count) =>
    `正在等 ${count} 位玩家回来，他们还有牌没出。`,
  seatHeld: '保留座位',
  cleared: '过关了！',
  cleanLifeBack: '零失误，赢回一条命。',
  cleanLevel: '零失误。',
  costLives: (lives) => `失去 ${lives} 条命。`,
  toLevel: (level) => `后进入第 ${level} 关`,
  playWhen: '觉得时机到了，就打出你最小的牌。',
  awayCards: (count) => `暂离，${count} 张牌`,
  away: '暂离',
  waiting: '等待中',
  gettingReady: '准备中',
  levelCleared: '已过关',
  lostCards: (cards, held) =>
    held === 0
      ? `失去 ${cards}，没有剩余手牌`
      : `失去 ${cards}，还剩 ${held} 张牌`,
  cards: (count) => `${count} 张牌`,
};
